/**
 * This feature's routes, as constants.
 *
 * Separate from `routes.tsx` so a screen can link to another screen without
 * importing the module that builds the route table — which would be a cycle,
 * since the table imports the screens.
 *
 * `$id` is TanStack's parameter syntax. Callers substitute it; there is no
 * helper for that on purpose, because a helper that took `Record<string,
 * string>` would accept a typo silently and a typed one would need a
 * generic per route.
 */

export const REFERENTIAL_PATHS = {
  articles: "/referentiel/articles",
  article: "/referentiel/articles/$id",
  families: "/referentiel/familles",
  sites: "/referentiel/sites",
  companies: "/referentiel/societes",
  pointsOfSale: "/referentiel/points-de-vente",
  depots: "/referentiel/depots",
  stock: "/referentiel/stocks",
  stockByDepot: "/referentiel/stock-par-depot",
  pricing: "/referentiel/baremes",
} as const;
